/**
 * 立体透视图相关action
 */
import oData from '../server/odata_equipment_client';
import rData from '../server/rest_client';
import Utils from '../script/utils.js';

export const SET_NETWORKNODES = 'SET_NETWORKNODES'
export const SET_NETWORKNODETYPERELATION = 'SET_NETWORKNODETYPERELATION'
export const SET_RELATIONS = 'SET_RELATIONS'
export const SET_2DMODE = 'SET_2DMODE'
export const SET_ADDEDDRAGGEDNODEIN3D = 'SET_ADDEDDRAGGEDNODEIN3D'

export function setNetworkNodes(networkNodes) {
    return {
        type: SET_NETWORKNODES,
        networkNodes
    }
}

export function setNetworkNodeTypeRelation(networkNodeTypeRelation) {
    return {
        type: SET_NETWORKNODETYPERELATION,
        networkNodeTypeRelation
    }
}

export function setRelations(relations) {
    return {
        type: SET_RELATIONS,
        relations
    }
}

export function set2DMode(b2DMode) {
    return {
        type: SET_2DMODE,
        b2DMode
    }
}

export function setAddedDraggedNodeIn3D(bAddedDraggedNodeIn3D) {
    return {
        type: SET_ADDEDDRAGGEDNODEIN3D,
        bAddedDraggedNodeIn3D
    }
}

//获取视图节点数据
export function getNetworkNodes(type, callback){
  return dispatch => {
    rData.getNetworkNodes(type, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(setNetworkNodes([]));
        callback && callback();
      }
      else {
        dispatch(setNetworkNodes(data.NetWorkNodes));
        callback && callback(data.NetWorkNodes);
      }
    }, (status)=>{
      dispatch(setNetworkNodes([]));
      callback && callback();
      Utils.showMessageDialog("提示","获取视图节点数据失败。");
    });
  }
}

//获取视图节点连线数据
export function getNetworkNodeLine(type, callback){
  return dispatch => {
    rData.getNetworkNodeLine(type, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(setRelations([]));
        callback && callback();
      }
      else {
        dispatch(setRelations(data.lines));
        callback && callback(data.lines);
      }
    }, (status)=>{
      dispatch(setRelations([]));
      callback && callback();
      Utils.showMessageDialog("提示","获取视图节点数据失败。");
    });
  }
}

export function getNetWorkNode(callback){
  return dispatch => {
    oData.getNetWorkNode(function(data) {
      dispatch(setNetworkNodes(data));
      callback && callback(data);
    }, function(status) {
      callback && callback([]);
    });
  }
}

export function getNetworkNodeTypeRelation(callback){
  return dispatch => {
    oData.getNetworkNodeTypeRelation(function(data) {
      dispatch(setNetworkNodeTypeRelation(data));
      callback && callback(data);
    }, function(status) {
      callback && callback([]);
    });
  }
}

export function getNetworkRelation(callback){
  return dispatch => {
    oData.getNetworkRelation(function(data) {
      dispatch(setRelations(data));
      callback && callback(data);
    }, function(status) {
      callback && callback([]);
    });
  }
}

export function setNetworkNodeXY(networkNodeXYData, callback){
  return dispatch => {
    let updateFunc = data => {
      var params = {
        RecId: data[0].id,
        XLocal: data[0].xLocal.toString(),
        YLocal: data[0].yLocal.toString()
      };
      oData.updateNodeXYLocal(params, ()=>{
        data.splice(0, 1);
        if (data.length > 0) {
          updateFunc(data);
        }
        else {
          callback && callback(1);
        }
      }, ()=>{
        data.splice(0, 1);
        if (data.length > 0) {
          updateFunc(data);
        }
        else {
          callback && callback(0);
        }
      });
    };
    updateFunc(networkNodeXYData);
  }
}

//更新NetWorkNode表
export function updateNetworkNode(params, callback) {
  return dispatch => {
    oData.getNodeType(params.monitorId, function(data) {
      if (data.length != 0) {
        oData.updateNodeType({RecId: data[0].RecId, NodeType: params.Level=='none' ? '' : params.Level}, function(data) {
          if(data && !data.hasOwnProperty('errorCode')){
    				callback && callback('success');
    			}else{
    				callback && callback('fail');
    			};
        }, function(status) {
          callback && callback('fail');
        });
      }
      else {
        oData.addNetworkNode({NodeType: params.Level, NodeId: params.monitorId, NodeName: params.monitorName, NodeRelationMonitor: params.monitorId}, function(data){
          if(data && !data.hasOwnProperty('errorCode')){
    				callback && callback('success');
    			}else{
    				callback && callback('fail');
    			};
        }, function(status) {
          callback && callback('fail');
        });
      }
    }, function(status) {
      callback && callback('fail');
    });
  }
}

//移除节点
export function deleteNetworkNode(monitorId, callback){
  return dispatch => {
    oData.deleteNetworkNode(monitorId, (res)=>{
      oData.deleteNetworkRelation2(monitorId, (res2)=>{
        callback && callback();
      });
    });
  }
}

//创建连接
export function createRelation(params, callback){
  return dispatch => {
    oData.getNodeType(params.node2_id, function(data){
      if (data.length != 0) {
        var params_1 = {
          FromType: params.node1_level <= data[0].NodeType ? params.node1_level : data[0].NodeType,
          ToType: params.node1_level <= data[0].NodeType ? data[0].NodeType : params.node1_level
        }
        oData.getNetworkNodeTypeRelation1(params_1, function(data1){
          if (data1.length != 0) {
            var params_2 = {
              RelationLevel: data1[0].RecId,
              FromNode: params.node1_level <= data[0].NodeType ? params.node1_id : params.node2_id,
              ToNode:params.node1_level <= data[0].NodeType ? params.node2_id : params.node1_id
            }
            oData.addNetworkRelation(params_2);
          }
          else {
            oData.addNetworkNodeTypeRelation(params_1, function(data2){
              var params_2 = {
                RelationLevel: data2.RecId,
                FromNode: params.node1_level <= data[0].NodeType ? params.node1_id : params.node2_id,
                ToNode:params.node1_level <= data[0].NodeType ? params.node2_id : params.node1_id
              }
              oData.addNetworkRelation(params_2);
            });
          }
        })
      }
    });
  }
}

//删除连接
export function deleteRelation(params, callback){
  return dispatch => {
    oData.deleteNetworkRelation(params, function(res) {
      callback && callback();
    });
  }
}
